/**
 * Left pointing arrow.
 * Uses `currentColor`.
 */
export function ArrowLeft({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
      strokeWidth="2"
    >
      <path d="M20 12L4 12M4 12L10 18M4 12L10 6" />
    </svg>
  )
}
